"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVICE_MEASURE = void 0;
const types_1 = require("./types");
const TABLET_MIN_WIDTH = 768;
const DESKTOP_MIN_WIDTH = 1024;
const WIDTH_NOT_DEFINED = -1;
exports.DEVICE_MEASURE = {
    [types_1.Device.DESKTOP]: {
        width: {
            min: DESKTOP_MIN_WIDTH,
            max: WIDTH_NOT_DEFINED,
        },
    },
    [types_1.Device.TABLET]: {
        width: {
            min: TABLET_MIN_WIDTH,
            max: DESKTOP_MIN_WIDTH - 1,
        },
    },
    [types_1.Device.MOBILE]: {
        width: {
            min: WIDTH_NOT_DEFINED,
            max: TABLET_MIN_WIDTH - 1,
        },
    },
};
//# sourceMappingURL=devicesMeasures.js.map